module.exports = __webpack_public_path__ + "img/6.cleaned_stainless_steel.9f9c018e.svg";